import { gql } from '../../../__generated__/graphql/catalog'

export const COLLECTION_PAGE_QUERY_OPTIMIZED = gql(`
  query CollectionPageQueryOptimized(
    $handle: String!
    $preview: Boolean = false
    $withPortal: Boolean = false
  ) {
    # FETCH_COLLECTION_LAYOUT primer
    collectionView(handle: $handle, preview: $preview) {
      ...CollectionLayoutFragment
    }
    portal(collectionHandle: $handle, preview: $preview) @include(if: $withPortal) {
      ...PortalStatic
    }
  }
`)
